import styled from "@emotion/styled"

const PostEventsEventInfo = styled.div`
  ${({ theme }) => theme.breakpoints.up("xl")} {
  }
`

export default PostEventsEventInfo
